module.exports = __webpack_public_path__ + "img/empty.2fffd5ad.svg";